import { Redirect, Route, Switch } from "react-router";

import PageTitle from "../../ui/PageTitle/PageTitle";

import { REPORT_URLS, IReportProps } from "./module/constants";
import { ROUTES } from "../../module/constants";

import ReportStepOne from "./ReportStepOne/ReportStepOne";
import ErrorPage from "../ErrorPage/Loadable";

import messages from "./module/messages";
import ReportStepTwo from "./ReportStepTwo/ReportStepTwo";

const ReportsReference = (props: IReportProps) => {
  return (
    <>
      <PageTitle title={messages.pageTitle} />
      <Switch>
        <Route strict exact path={ROUTES.REPORT} component={ReportStepOne} />
        <Route
          strict
          exact
          path={REPORT_URLS.REPORT_DETAIL}
          component={ReportStepTwo}
        />
        <Route path={ROUTES.FORBIDDEN} component={ErrorPage} />
        <Redirect path={"*"} to={{ pathname: ROUTES.FORBIDDEN }} />
      </Switch>
    </>
  );
};

export default ReportsReference;
